import API from "../axiosConfig";

export const getMotifs = async () => {
  // Implementation
  try {
    const response = await API.get("/cancellation-reasons");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createMotif = async (payload) => {
  // Implementation.
  try {
    const response = await API.post("/cancellation-reasons", { ...payload });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateMotif = async (id, payload) => {
  // Implementation
  try {
    const response = await API.put(`/cancellation-reasons/${id}`, {
      ...payload,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMotifsInfraction = async () => {
  // Implementation
  try {
    const response = await API.get("/cancellation-reasons/infraction");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMotifsWarning = async () => {
  // Implementation
  try {
    const response = await API.get("/cancellation-reasons/warning");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMotifsSubscription = async () => {
  try {
    const response = await API.get("/cancellation-reasons/subscription");
    return response.data;
  } catch (error) {
    throw error;
  }
};